import type { JSX } from "react";

import type { ISite } from "@similarweb/ui-components";
import { ListItemKeyword } from "@similarweb/ui-components";

import type { OnSearchItemClick } from "app/pages/activation/components/HomeSearch/types";
import { getKeywordResults } from "app/services/solutions2Services/HomepageDataFetchers/NewModulesHomepageDataFetcher";

import { createKeywordUrl } from "./createKeywordUrl";
import { redirectToUrl } from "./redirectToUrl";

export const generateKeywordResponse = async (query: string, onClick?: OnSearchItemClick) => {
    const keywordResults = await getKeywordResults(query);

    const createKeywordSearchResultItem = (item: ISite): JSX.Element => {
        const { name } = item;
        const url = createKeywordUrl(name);

        const onItemClick = () => {
            onClick?.(name, "search_result");

            redirectToUrl(url);
        };

        return (
            <ListItemKeyword
                key={`${name}`}
                iconName="keywords"
                text={name}
                onClick={onItemClick}
            />
        );
    };

    return keywordResults.map(createKeywordSearchResultItem);
};
